import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { CostAmendmentPage } from '@/features/billing/pages/CostAmendmentPage';
import { approvalSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/cost-amendment')({
  validateSearch: approvalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR Cost Amendment">
      <Suspense fallback={<PageLoader />}>
        <CostAmendmentPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
